import {
  addObj,
  getAll,
  getPage,
  getDetail,
  modifyObj,
  deleteObj,
  getMyAll,
  getMyPage,
  confirmRemind
} from '@/api/vehiclemaintenanceplanserv'

export default {
  state: {
    state_VehicleMaintenancePlan_AddObjResult: null,
    state_VehicleMaintenancePlan_GetAllResult: null,
    state_VehicleMaintenancePlan_GetPageResult: null,
    state_VehicleMaintenancePlan_GetDetailResult: null,
    state_VehicleMaintenancePlan_ModifyObjResult: null,
    state_VehicleMaintenancePlan_DeleteObjResult: null,
    state_VehicleMaintenancePlan_GetMyAllResult: null,
    state_VehicleMaintenancePlan_GetMyPageResult: null,
    state_VehicleMaintenancePlan_ConfirmRemindResult: null
  },
  mutations: {
    SET_VEHICLEMAINTENANCEPLAN_ADDOBJ_RESULT: (state, rst) => {
      state.state_VehicleMaintenancePlan_AddObjResult = rst
    },
    SET_VEHICLEMAINTENANCEPLAN_GETALL_RESULT: (state, rst) => {
      state.state_VehicleMaintenancePlan_GetAllResult = rst
    },
    SET_VEHICLEMAINTENANCEPLAN_GETPAGE_RESULT: (state, rst) => {
      state.state_VehicleMaintenancePlan_GetPageResult = rst
    },
    SET_VEHICLEMAINTENANCEPLAN_GETDETAIL_RESULT: (state, rst) => {
      state.state_VehicleMaintenancePlan_GetDetailResult = rst
    },
    SET_VEHICLEMAINTENANCEPLAN_MODIFYOBJ_RESULT: (state, rst) => {
      state.state_VehicleMaintenancePlan_ModifyObjResult = rst
    },
    SET_VEHICLEMAINTENANCEPLAN_DELETEOBJ_RESULT: (state, rst) => {
      state.state_VehicleMaintenancePlan_DeleteObjResult = rst
    },
    SET_VEHICLEMAINTENANCEPLAN_GETMYALL_RESULT: (state, rst) => {
      state.state_VehicleMaintenancePlan_GetMyAllResult = rst
    },
    SET_VEHICLEMAINTENANCEPLAN_GETMYPAGE_RESULT: (state, rst) => {
      state.state_VehicleMaintenancePlan_GetMyPageResult = rst
    },
    SET_VEHICLEMAINTENANCEPLAN_CONFIRMREMIND_RESULT: (state, rst) => {
      state.state_VehicleMaintenancePlan_ConfirmRemindResult = rst
    }
  },
  actions: {
    VehicleMaintenancePlanServ_AddObj ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        addObj(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_VEHICLEMAINTENANCEPLAN_ADDOBJ_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_VEHICLEMAINTENANCEPLAN_ADDOBJ_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    VehicleMaintenancePlanServ_GetAll ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        getAll(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_VEHICLEMAINTENANCEPLAN_GETALL_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_VEHICLEMAINTENANCEPLAN_GETALL_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    VehicleMaintenancePlanServ_GetPage ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        getPage(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_VEHICLEMAINTENANCEPLAN_GETPAGE_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_VEHICLEMAINTENANCEPLAN_GETPAGE_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    VehicleMaintenancePlanServ_GetDetail ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        getDetail(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_VEHICLEMAINTENANCEPLAN_GETDETAIL_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_VEHICLEMAINTENANCEPLAN_GETDETAIL_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    VehicleMaintenancePlanServ_ModifyObj ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        modifyObj(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_VEHICLEMAINTENANCEPLAN_MODIFYOBJ_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_VEHICLEMAINTENANCEPLAN_MODIFYOBJ_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    VehicleMaintenancePlanServ_DeleteObj ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        deleteObj(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_VEHICLEMAINTENANCEPLAN_DELETEOBJ_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_VEHICLEMAINTENANCEPLAN_DELETEOBJ_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    VehicleMaintenancePlanServ_GetMyAll ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        getMyAll(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_VEHICLEMAINTENANCEPLAN_GETMYALL_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_VEHICLEMAINTENANCEPLAN_GETMYALL_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    VehicleMaintenancePlanServ_GetMyPage ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        getMyPage(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_VEHICLEMAINTENANCEPLAN_GETMYPAGE_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_VEHICLEMAINTENANCEPLAN_GETMYPAGE_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    VehicleMaintenancePlanServ_ConfirmRemind ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        confirmRemind(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_VEHICLEMAINTENANCEPLAN_CONFIRMREMIND_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_VEHICLEMAINTENANCEPLAN_CONFIRMREMIND_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    }
  },
  getters: {
    get_VehicleMaintenancePlan_AddObjResult: state => {
      return state.state_VehicleMaintenancePlan_AddObjResult
    },
    get_VehicleMaintenancePlan_GetAllResult: state => {
      return state.state_VehicleMaintenancePlan_GetAllResult
    },
    get_VehicleMaintenancePlan_GetPageResult: state => {
      return state.state_VehicleMaintenancePlan_GetPageResult
    },
    get_VehicleMaintenancePlan_GetDetailResult: state => {
      return state.state_VehicleMaintenancePlan_GetDetailResult
    },
    get_VehicleMaintenancePlan_ModifyObjResult: state => {
      return state.state_VehicleMaintenancePlan_ModifyObjResult
    },
    get_VehicleMaintenancePlan_DeleteObjResult: state => {
      return state.state_VehicleMaintenancePlan_DeleteObjResult
    },
    get_VehicleMaintenancePlan_GetMyAllResult: state => {
      return state.state_VehicleMaintenancePlan_GetMyAllResult
    },
    get_VehicleMaintenancePlan_GetMyPageResult: state => {
      return state.state_VehicleMaintenancePlan_GetMyPageResult
    },
    get_VehicleMaintenancePlan_ConfirmRemindResult: state => {
      return state.state_VehicleMaintenancePlan_ConfirmRemindResult
    }
  }
}
